import React from 'react';
import { useParams } from 'react-router';
import { useQuery } from '@apollo/client';
import { Card, Spin } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { PrivateComponent } from 'components/auth';
import AssignApproverModal from 'components/layout/AssignApproverModal';
import { GET_REPORT_SUBMISSION_FORM_DETAIL } from 'gql/reportSubmissions';
import ReportReviewForm from './ReportReviewForm';
import ReportReviewDetail from './ReportReviewDetail';

const approver = ({ appointedReviewer, sequence, refetchQueries }) => {
  const { reportControlType, department, faculty, role } = appointedReviewer;
  if (reportControlType !== 'ASSIGN') {
    return null;
  }

  return (
    <PrivateComponent expectedScopeType={['ASSIGN_APPROVER']}>
      {role === null ? (
        <AssignApproverModal
          applicationType="REPORT_SUBMISSION"
          sequence={sequence}
          refetchQueries={refetchQueries}
          buttonText="Assign Reviewer"
        />
      ) : (
        <>
          Assigned to: {role?.name}
          {department?.abbreviation
            ? ` @ ${department.abbreviation}`
            : faculty?.abbreviation
            ? ` @ ${faculty.abbreviation}`
            : ''}
          <AssignApproverModal
            applicationType="REPORT_SUBMISSION"
            sequence={sequence}
            refetchQueries={refetchQueries}
            buttonText="Re-assign Reviewer"
            prefixIcon={<EditOutlined />}
          />
        </>
      )}
    </PrivateComponent>
  );
};

const ReviewSection = () => {
  const { id } = useParams();
  const { data, loading } = useQuery(GET_REPORT_SUBMISSION_FORM_DETAIL, {
    variables: { ids: [id] },
  });
  const refetchQueries = [
    {
      query: GET_REPORT_SUBMISSION_FORM_DETAIL,
      variables: { ids: [id] },
    },
  ];
  const formDetail = data?.reportSubmissions[0]?.formDetail;
  const isCurrentAppointedReviewer =
    data?.reportSubmissions[0]?.isCurrentAppointedReviewer;

  return (
    <>
      <Spin spinning={loading}>
        {formDetail?.sections?.map(
          ({
            sequence,
            name,
            detail,
            completedBy,
            date,
            appointedReviewer,
          }) => (
            <Card
              title={name}
              key={`reviewForm-${sequence}`}
              extra={approver({
                appointedReviewer,
                sequence,
                refetchQueries,
              })}
            >
              {sequence >= formDetail.sequence ? (
                <ReportReviewForm
                  detail={detail}
                  sequence={sequence}
                  isCurrent={sequence === formDetail.sequence}
                  isCurrentAppointedReviewer={isCurrentAppointedReviewer}
                />
              ) : (
                <ReportReviewDetail
                  detail={detail}
                  completedBy={completedBy}
                  date={date}
                />
              )}
            </Card>
          )
        )}
      </Spin>
    </>
  );
};

export default ReviewSection;
